<template>
  <div class="question-view text-drag-2" ref="questionView">
    <div class="quest" :style="`${mode == 'viewAnswer' ? `--beforeShow: '';` : `--beforeShow: none;`}`">
      <FixedFontSizeSelector>
        <div class="title">
          <vue-mathjax @onRenderComplete="onRenderComplete(++mathjaxNum)" :formula="form.title" :safe="false"/>
        </div>

        <div class="choice-list">
          <div :class="['choice-single', curClickSelect == idx && 'cur-select', alreadyExist.includes(idx) && 'already-exist']"
               v-drag-choice="{self, className: '.drag-area', idx}"
               v-show="its.content" v-for="(its, idx) in choice" :key="idx" :id="'single' + idx"
               @dragstart="dragStart($event, idx)" @mousedown="clickEvent($event, idx)">
            <vue-mathjax @onRenderComplete="onRenderComplete(++mathjaxNum)" v-if="its.type == 'text'" :formula="its.content" :safe="false"/>
            <div class="image" v-else :style="{backgroundImage: `url(${its.content})`}"></div>
          </div>
        </div>

        <div class="area">
          <div class="area-single" @drop="drop($event, key)" @dragover="dragover($event)"
               v-for="(key, idx) in Object.keys(area)" :key="idx">
            <div class="area-name">
              <vue-mathjax @onRenderComplete="onRenderComplete(++mathjaxNum)" :formula="area[key].name" :safe="false"/>
            </div>
            <div class="drag-area" @click.stop="eventParent(key)">
              <div class="sle-choice" @click="removeAnswer(key, index)" :data-value="its.content" v-for="(its, index) in area[key].areaData" :key="index">
                <vue-mathjax @onRenderComplete="onRenderComplete(++mathjaxNum)" v-if="its.type == 'text'" :formula="its.content" :safe="false"/>
                <div class="image" v-else :style="{backgroundImage: `url(${its.content})`}"></div>
              </div>
            </div>
          </div>
        </div>
      </FixedFontSizeSelector>
    </div>
  </div>
</template>

<script>
import {getNodeOffset} from '@/utils/scroll-to'
import FixedFontSizeSelector from '@/views/examination/components/dialog/FontSizeSelector'
let dragText = {
  bind(el, binding) {
    // if (window.matchMedia("(max-width: 1080px)").matches) { // 可以根据需要设置不同的断点
    //   mobile(el, binding)
    // } else {
    //   pc(el, binding)
    // }
    mobile(el, binding)
    pc(el, binding)
  }
}

function mobile(el, binding) {
  el.ontouchstart = (e) => {
    let { value } = binding,
        {className, self, idx} = value

    let {layerX, layerY, pageX, pageY} = e,
        elPageX = pageX - layerX,
        elPageY = pageY - layerY,
        elWidth = el.offsetWidth,
        elHeight = el.offsetHeight
    console.log(elPageX, elPageY)

    let containers = document.querySelectorAll(className),
        containIdx = null,
        containArea = []

    for(let i = 0; i < containers.length; i++) {
      let container = containers[i],
          {left, top} = getNodeOffset(container),
          width = container.offsetWidth,
          height = container.offsetHeight,
          bottom = top + height,
          right = left + width
      containArea.push([left, top, right, bottom])
    }

    let copyEl = el.cloneNode(true)
    copyEl.style = `
      position: absolute;
      top: ${elPageY}px;
      left: ${elPageX}px;
      width: ${elWidth}px;
      height: ${elHeight}px;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      padding: 10px;
      background-color: #f8ae64;
      border-radius: 8px;
      box-shadow: 1px 2px 2px 1px #ccc;
      font-size: 14px;
      cursor: pointer;
      user-select: none;
      margin: 0 10px 10px 0;
      box-sizing: border-box;
      font-size: 16px;
    `
    let img = copyEl.querySelector('.image')

    if(img) {
      img.style.width = '60px'
      img.style.height = '60px'
      img.style.backgroundSize = 'contain'
      img.style.backgroundRepeat = 'no-repeat'
      img.style.backgroundPosition = 'center center'
    }

    document.body.append(copyEl)

    document.body.ontouchmove = (e) => {
      pageX = e.pageX
      pageY = e.pageY
      elPageX = pageX - layerX
      elPageY = pageY - layerY

      copyEl.style.top = `${elPageY}px`
      copyEl.style.left = `${elPageX}px`

      for(let i = 0; i < containArea.length; i++) {
        // Number[4]: left, top, right, bottom
        let item = containArea[i]
        if(pageX >= item[0]
            && pageY >= item[1]
            && pageX <= item[2]
            && pageY <= item[3]) {
          containIdx = i
          break;
        } else {
          containIdx = null
        }
      }
    }

    document.body.ontouchend = () => {
      if(containIdx != null) {
        let keys = ['left', 'right']
        console.log(`第${keys[containIdx]}个`)
        console.log(idx)
        self.assignment(idx, keys[containIdx])
      }
      document.body.removeChild(copyEl)
      document.body.ontouchend = null
      document.body.ontouchmove = null
    }
  }
}

function pc(el, binding) {
  el.onmousedown = (e) => {
    let { value } = binding,
        {className, self, idx} = value

    let {layerX, layerY, pageX, pageY} = e,
        elPageX = pageX - layerX,
        elPageY = pageY - layerY,
        elWidth = el.offsetWidth,
        elHeight = el.offsetHeight
    console.log(elPageX, elPageY)

    let containers = document.querySelectorAll(className),
        containIdx = null,
        containArea = []

    for(let i = 0; i < containers.length; i++) {
      let container = containers[i],
          {left, top} = getNodeOffset(container),
          width = container.offsetWidth,
          height = container.offsetHeight,
          bottom = top + height,
          right = left + width
      containArea.push([left, top, right, bottom])
    }

    let copyEl = el.cloneNode(true)
    copyEl.style = `
      position: absolute;
      top: ${elPageY}px;
      left: ${elPageX}px;
      width: ${elWidth}px;
      height: ${elHeight}px;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      padding: 10px;
      background-color: #f8ae64;
      border-radius: 8px;
      box-shadow: 1px 2px 2px 1px #ccc;
      font-size: 14px;
      cursor: pointer;
      user-select: none;
      margin: 0 10px 10px 0;
      box-sizing: border-box;
      font-size: 16px;
    `
    let img = copyEl.querySelector('.image')

    if(img) {
      img.style.width = '60px'
      img.style.height = '60px'
      img.style.backgroundSize = 'contain'
      img.style.backgroundRepeat = 'no-repeat'
      img.style.backgroundPosition = 'center center'
    }

    document.body.append(copyEl)

    document.body.onmousemove = (e) => {
      pageX = e.pageX
      pageY = e.pageY
      elPageX = pageX - layerX
      elPageY = pageY - layerY

      copyEl.style.top = `${elPageY}px`
      copyEl.style.left = `${elPageX}px`

      for(let i = 0; i < containArea.length; i++) {
        // Number[4]: left, top, right, bottom
        let item = containArea[i]
        if(pageX >= item[0]
            && pageY >= item[1]
            && pageX <= item[2]
            && pageY <= item[3]) {
          containIdx = i
          break;
        } else {
          containIdx = null
        }
      }
    }

    document.body.onmouseup = () => {
      if(containIdx != null) {
        let keys = ['left', 'right']
        console.log(`第${keys[containIdx]}个`)
        console.log(idx)
        self.assignment(idx, keys[containIdx])
      }
      document.body.removeChild(copyEl)
      document.body.onmouseup = null
      document.body.onmousemove = null
    }
  }
}

export default {
  components: {
    FixedFontSizeSelector
  },
  props: ['form', 'mode'],
  directives: {
    'drag-choice': dragText
  },
  data() {
    let letter = new Array(26).fill().map((its, idx) => its = String.fromCharCode(65 + idx))

    return {
      mathjaxNum: 0,
      letter,
      topic: '请将选项拖拽至正确的空格中。',
      curClickSelect: null,

      choice: [],
      question: [],

      area: {
        left: {
          name: '正方形',
          areaData: [],
          isExist: []
        },
        right: {
          name: '长方形',
          areaData: [],
          isExist: []
        },
      },
      answer_results: {
        id: null,
        student_choices: []
      },
      recordQuestion: [],
      // 记录已使用的文字选项
      alreadyExist: [],
      self: this,
      // 记录答题次数
      limit: 0
    }
  },
  watch: {
    'form.id': {
      handler() {
        this.initData()
      },
      deep: true
    }
  },
  methods: {
    onRenderComplete(i) {
      let num = 1 + 2 + this.choice.filter(its => its.type == 'text' && its).length

      if(this.mode == 'viewAnswer') {
        num += this.area['left'].areaData.filter(its => its.type == 'text' && its).length +
            this.area['right'].areaData.filter(its => its.type == 'text' && its).length
      }

      if(i == num) {
        this.$parent.loading = false
      }
    },
    // 重置
    resetting() {
      // 数据清空
      let { area } = this
      area.left.areaData = []
      area.left.isExist = []
      area.right.areaData = []
      area.right.isExist = []
      this.$emit('permissions', false)
      this.limit = 0

      this.recordQuestion = []
      this.alreadyExist = []
      this.answer_results = {
        id: null,
        student_choices: []
      }
      this.repariRecordQuestion()
    },
    repariRecordQuestion() {
      this.$emit('repariRecordQuestion', this.recordQuestion, this.limit)
    },
    showTrueFalse() {
      let { form, recordQuestion, area, choice } = this,
          { left, right } = area, answers = {},
          blocks = document.querySelectorAll('.drag-area')

      if(recordQuestion.length == 0) {
        return ;
      }

      this.limit = 1

      form.answers.filter((its, idx) => {
        if(idx == 0) answers.left = its.value.split(',').map(its => choice[its].content)
        else answers.right = its.value.split(',').map(its => choice[its].content)
      })

      console.log(recordQuestion)
      // 回显答案
      for(let i = 0; i < recordQuestion.length; i++) {
        for(let j = 0; j < recordQuestion[i].length; j++) {
          let item = recordQuestion[i][j]
          // content = choice[item].content
          if(i == 0) {
            left.areaData.push(choice[item])
            left.isExist.push(choice[item].content)
          } else {
            right.areaData.push(choice[item])
            right.isExist.push(choice[item].content)
          }
        }
      }

      // 回显对错
      setTimeout(() => {
        for(let i = 0; i < blocks.length; i++) {
          let block = blocks[i],
              areas = block.querySelectorAll('.sle-choice')

          for(let j = 0; j < areas.length; j++) {
            let value = areas[j].dataset.value
            console.log(areas[j])
            console.log(value)

            if(this.mode == 'question') {
              continue ;
            }

            if(i == 0)
              if(answers.left.includes(value)) areas[j].classList.add('determine-success-br')
              else areas[j].classList.add('determine-error-br')
            else
            if(answers.right.includes(value)) areas[j].classList.add('determine-success-br')
            else areas[j].classList.add('determine-error-br')
          }
        }
        console.log(form)
      }, 500);
    },
    dragStart(e, idx) {
      e.dataTransfer.setData('textDragMsg', idx)
    },
    clickEvent(e, idx) {
      this.curClickSelect = idx
    },
    eventParent(key) {
      if(this.curClickSelect != null) {
        let idx = this.curClickSelect
        this.assignment(idx, key)
      }

    },
    dragover(e) {
      e.preventDefault()
    },

    drop(e, key) {
      let idx = e.dataTransfer.getData('textDragMsg')

      this.assignment(idx, key)
    },
    assignment(idx, key) {
      console.log(idx, key)
      let { area } = this,
          cte = this.choice[idx].content
      console.log(this.choice[idx])
      console.log(area[key])
      if(!area[key].isExist.includes(cte)) {
        area[key].isExist.push(cte)
        area[key].areaData.push(this.choice[idx])
      }

      this.saveAnswers()
      console.log(this.answer_results.student_choices)

      this.curClickSelect = null
    },
    saveAnswers() {
      let { area } = this
      this.alreadyExist = []
      // 重置数据
      this.answer_results.student_choices = []
      this.recordQuestion = []
      if(area.left.areaData.length > 0 || area.right.areaData.length > 0){
        this.$emit('permissions', true)
        this.limit = 1
        console.log(this.choice)
        let {left, right} = this.area,
            filterKey = this.choice.map(its => its.content),
            lVal = left.areaData.map(its => filterKey.indexOf(its.content)).sort(),
            rVal = right.areaData.map(its => filterKey.indexOf(its.content)).sort()
        console.log(right.areaData, filterKey)
        this.answer_results.student_choices.push({value: lVal.join(',')})
        this.answer_results.student_choices.push({value: rVal.join(',')})

        console.log(lVal, rVal)
        this.alreadyExist.push(...lVal, ...rVal)
        this.recordQuestion = [ lVal, rVal ]
      } else {
        this.$emit('permissions', false)
        this.limit = 0
      }

      console.log(this.answer_results.student_choices)
    },
    // 移除答案 recordQuestion
    removeAnswer(key, idx) {
      this.area[key].areaData.splice(idx, 1)
      this.area[key].isExist.splice(idx, 1)
      let {left, right} = this.area,
          lArea = left.areaData,
          rArea = right.areaData

      this.saveAnswers()
      if(lArea.length == 0 && rArea.length == 0) {
        this.$emit('permissions', false)
        this.limit = 0
      }
    },
    initData() {
      this.answer_results = {
        id: null,
        student_choices: []
      }
      this.recordQuestion = []
      this.choice = []
      this.question = []

      this.area = {
        left: {
          name: '正方形',
          areaData: [],
          isExist: []
        },
        right: {
          name: '长方形',
          areaData: [],
          isExist: []
        },
      }

      let content = JSON.parse(this.form.content)
      console.log(content)
      for(let i = 0; i < content.ligatureList.length; i++) {
        let {left, right} = content.ligatureList[i]
        if(right.type == 'text')
          this.choice.push({content: right.textValue, type: 'text'})
        else
          this.choice.push({content: right.imgValue, type: 'image'})
        if(left) {
          let areaKeys = Object.keys(this.area)
          this.area[areaKeys[i]].name = left.value
          // // 还原答案
          // let data = this.choice.filter((its, i) => left.rightTips.includes(i) && its)
          // this.area[areaKeys[i]].areaData = JSON.parse(JSON.stringify(data))
          // this.area[areaKeys[i]].isExist = JSON.parse(JSON.stringify(data))
        }
      }
      setTimeout(() => this.showTrueFalse(), 500)
    }
  },
  created() {
    // transfer.$on('textDrag', ({question, topic, choice}) => {
    //   this.topic = topic
    //   this.question = JSON.parse(JSON.stringify(question))
    //   this.choice = JSON.parse(JSON.stringify(choice))
    // })
    this.initData()
  }
}
</script>

<style scoped lang="scss">
@import url('../../static/pubile.scss');

.question-view {
  width: 100%;
  height: 400px;
  padding: 20px 0;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 10px;
  touch-action: none;

  /* 核心：彻底禁止这个盒子里的下拉刷新 + 回弹 */
  overscroll-behavior: none;min-height: 0;
  .quest {
    width: 100%;
    height: 100%;
    display: flex;
    // flex-direction: column;
    flex-wrap: wrap;

    .title {
      width: 100%;
      font-size: 15px;
      color: #333;
    }

    .choice-list {
      width: 100%;
      margin-top: 20px;
      display: flex;
      justify-content: flex-start;
      align-content: flex-start;
      flex-wrap: wrap;
      // grid-template-columns: repeat(5, 100px);
      // grid-template-rows: repeat(2, 34px);
      // grid-row-gap: 10px;
      // grid-column-gap: 10px;
      .choice-single {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        min-width: 40px;
        width: fit-content;
        height: fit-content;
        padding: 10px;
        background-color: #f8ae64;
        border-radius: 8px;
        box-shadow: 1px 2px 2px 1px #ccc;
        font-size: 14px;
        cursor: pointer;
        user-select: none;
        margin: 0 10px 10px 0;
        box-sizing: border-box;
        font-size: 16px;

        &:hover {
          opacity: .8;
        }

        .image {
          width: 60px;
          height: 60px;
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center center;
        }
      }

      .cur-select {
        box-shadow: 0px 0px 10px 2px orange;
      }

      .already-exist {
        background-color: #c0c4cc !important;
      }
    }

    .area {
      width: 100%;
      flex: 1;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .area-single {
        width: calc(50% - 20px);
        height: 100%;
        background-color: #fee8d2;
        border-radius: 30px;

        .area-name {
          width: 100%;
          height: 40px;
          background-color: #fcd2ab;
          color: #333;
          text-align: center;
          font-weight: 700;
          font-size: 18px;
          line-height: 40px;
          border-radius: 30px 30px 0 0;
        }

        .drag-area {
          width: 100%;
          height: 195px;
          overflow: auto;
          padding: 10px 0 0 10px;
          box-sizing: border-box;
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          align-content: flex-start;

          .sle-choice {
            text-align: center;
            box-shadow: 1px 2px 2px 1px #ccc;
            min-width: 60px;
            width: fit-content;
            height: fit-content;
            padding: 10px;
            border-radius: 5px;
            background-color: #f8ae64;
            margin-right: 10px;
            margin-bottom: 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            font-size: 16px;

            &:hover {
              opacity: .7;
            }
            .image {
              width: 60px;
              height: 60px;
              background-size: contain;
              background-repeat: no-repeat;
              background-position: center center;
            }
          }
        }
      }
    }

  }
}

.text-drag-2 {
  padding: 20px;
}
</style>